<template>
  <div class="right_col" role="main">
    <div class="row">
      <h3>編輯商家資料</h3>
      <hr />
    </div>
    <div class="row">
      <h4>
        使用說明：
        <p>1. 填入商店名稱，聯絡人，聯絡電話</p>
        <p>
          2.
          若商家需要使用APP叫車，則需要在自訂地標建立地標，並且選擇建立地標上車地點
        </p>
        <p>3. 若有問題可以聯絡資通行動技術支援</p>
      </h4>
    </div>
    <hr />
    <h2>一、商家基本資料</h2>
    <div
      style="
        background: white;
        padding: 10px;
        border: 1px #8c8c8c solid;
        border-radius: 5px;
      "
    >
      <el-row :gutter="20">
        <el-col :span="4">
          <h4>商家名稱: *</h4>
          <el-input v-model="store.name" placeholder="商家名稱"></el-input>
        </el-col>
        <el-col :span="4">
          <h4>聯絡人: *</h4>
          <el-input
            v-model="store.contact_person"
            placeholder="聯絡人"
          ></el-input>
        </el-col>
        <el-col :span="4">
          <h4>備註: *</h4>
          <el-input v-model="store.note" placeholder="備註"></el-input>
        </el-col>
        <el-col :span="4">
          <h4>企業折扣:</h4>
          <el-input
            v-model="store.companyDiscount"
            placeholder="企業折扣"
          ></el-input>
        </el-col>
        <el-col :span="4">
          <h4>司機折扣:</h4>
          <el-input
            v-model="store.driverDiscount"
            placeholder="司機折扣"
          ></el-input>
        </el-col>
        <el-col :span="4">
          <el-button
            type="primary"
            @click="updatedStore()"
            :loading="isModifyStoreLoading"
          >
            修改商家資料
          </el-button>
          <el-button type="danger" @click="deleteStore()">刪除商家</el-button>
        </el-col>
      </el-row>
    </div>
    <h2>二、聯絡電話:</h2>
    <div
      style="
        background: white;
        padding: 10px;
        border: 1px #8c8c8c solid;
        border-radius: 5px;
      "
    >
      <el-row :gutter="20" type="flex">
        <el-col :span="6">
          <div
            v-for="(item, index) in phoneList"
            :key="item + index"
            style="
              width: 250px;
              display: inline;
              margin-left: 10px;
              margin-button: 10px;
            "
          >
            <h4 style="width: 150px">({{ index + 1 }}). {{ item }}</h4>
            <el-button
              type="danger"
              icon="el-icon-delete"
              circle
              style="margin-left: 10px"
              @click="removePhone(item)"
            ></el-button>
          </div>
        </el-col>
        <el-col :span="12" :offset="6">
          <el-form ref="form" label-width="70px" :inline="true">
            <el-form-item label="聯絡電話">
              <el-input v-model="phoneNumber"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                icon="el-icon-edit"
                @click="addNewPhone"
                circle
              ></el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>
    <h2>三、定點叫車APP設定:</h2>
    <div
      style="
        background: white;
        padding: 10px;
        border: 1px #8c8c8c solid;
        border-radius: 5px;
      "
    >
      <el-row :gutter="20">
        <el-col :span="4">
          <h4>APP帳號:*(數字)</h4>
          <el-input v-model="store.account"></el-input>
        </el-col>
        <el-col :span="4">
          <h4>APP密碼:*(數字)</h4>
          <el-button
            v-if="store.passengerId !== ''"
            type="warning"
            @click="openModal()"
          >
            修改密碼
          </el-button>
          <el-input v-else v-model="store.password" placeholder=""></el-input>
        </el-col>
        <el-col :span="4">
          <h4>可派車:*</h4>
          <select
            id="heard"
            class="form-control fontSize16"
            required=""
            v-model="store.isAuthorize"
            @change="setHailing(store.isHailingTaxi)"
          >
            <option :value="true">是</option>
            <option :value="false">否</option>
          </select>
        </el-col>
        <el-col :span="1" :offset="9">
          <el-button
            v-if="store.passengerId === ''"
            type="primary"
            @click="createAppAccount()"
          >
            新增定點叫車APP
          </el-button>
          <el-button
            v-else
            type="primary"
            @click="updateAppInfo()"
            :loading="isUpdareAppInfo"
          >
            更新APP資料
          </el-button>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="margin-top: 30px">
        <el-col :span="7">
          <h4>1. APP商家設定地址:</h4>
          <el-autocomplete
            style="width: 400px"
            v-model="keywordFindLandmark"
            :fetch-suggestions="searchLandmark"
            placeholder="請輸入地標"
            @select="selectLandmark"
          ></el-autocomplete>
        </el-col>
        <el-col :span="6">
          <h4>2. 修改地址:</h4>
          <el-input v-model="store.address"></el-input>
        </el-col>
        <el-col :span="4">
          <h4>3. 派遣區:</h4>
          <el-input v-model="store.dispatchName"></el-input>
        </el-col>
        <el-col :span="5">
          <h4>4. GPS:</h4>
          <h6>
            {{
              store.address_gps === null ? '' : store.address_gps.coordinates
            }}
          </h6>
        </el-col>
      </el-row>
    </div>
    <div
      style="
        background: white;
        padding: 10px;
        border: 1px #8c8c8c solid;
        border-radius: 5px;
        margin-top: 8px;
      "
    >
      <el-collapse accordion>
        <el-collapse-item>
          <template slot="title">選擇店家可使用的服務選項</template>
          <el-alert
            title="依照個別商家都需求，選擇不同的服務，特約商家可以在定點叫車機上做選擇。"
            type="info"
          ></el-alert>
          <div>
            <driver-service-checkbox
              ref="driverServiceList"
            ></driver-service-checkbox>
          </div>
          <div>
            <el-button type="primary" @click="updateService">更新</el-button>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <div
      style="
        background: white;
        padding: 10px;
        border: 1px #8c8c8c solid;
        border-radius: 5px;
        margin-top: 8px;
      "
    >
      <el-collapse accordion>
        <el-collapse-item>
          <template slot="title">設定時段叫車微調時間</template>
          <el-alert
            title="依照個別商家都需求，選擇不同時段，要加減得分鐘數，若需要剪分則輸入-1; 若需要加分則輸入 1"
            type="info"
          ></el-alert>
          <el-table :data="tableData" style="width: 100%">
            <el-table-column label="種類">
              <template slot-scope="scope">
                <el-select
                  :disabled="scope.row.isload"
                  v-model="scope.row.type"
                  placeholder="請選擇"
                  @change="selectAssginOption(scope)"
                >
                  <el-option
                    v-for="item in assginOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="時間範圍" width="300px">
              <template slot-scope="scope">
                <template v-if="!scope.row.isload">
                  {{ scope.row.isload }}
                  <el-time-select
                    style="margin-bottom: 8px"
                    placeholder="起始時間"
                    v-model="scope.row.start_date"
                    :picker-options="{
                      start: '00:00',
                      step: '00:15',
                      end: '24:00',
                    }"
                  ></el-time-select>
                  <el-time-select
                    placeholder="結束時間"
                    v-model="scope.row.end_date"
                    :picker-options="{
                      start: '00:00',
                      step: '00:15',
                      end: '24:00',
                    }"
                  ></el-time-select>
                </template>
                <template v-else>
                  {{ scope.row.start_date }} - {{ scope.row.end_date }}
                </template>
              </template>
            </el-table-column>
            <el-table-column label="分鐘數">
              <template slot-scope="scope">
                <el-input
                  v-if="!scope.row.isload"
                  v-model="scope.row.minutes"
                  placeholder="-1/1  分鐘數"
                ></el-input>
                <template v-else>{{ scope.row.minutes }}分鐘</template>
              </template>
            </el-table-column>
            <el-table-column align="right">
              <template slot="header" slot-scope="scope">
                <el-button type="info" @click="addRule">新增規則</el-button>
              </template>
              <template slot-scope="scope">
                <el-button
                  type="danger"
                  icon="el-icon-delete"
                  circle
                  v-if="scope.row.isload"
                  @click="handleDelete(scope.$index, scope.row)"
                ></el-button>
                <el-button
                  v-if="!scope.row.isload"
                  type="primary"
                  icon="el-icon-circle-plus-outline"
                  circle
                  @click="handleAdd(scope.$index, scope.row)"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-collapse-item>
      </el-collapse>
    </div>
    <hr class="hr-gray" />
    <div
      style="
        background: white;
        padding: 10px;
        border: 1px #8c8c8c solid;
        border-radius: 5px;
      "
    >
      <el-row :gutter="20">
        <el-col :span="4">
          <h4>上次修改人員:</h4>
          <el-input
            v-model="store.modifyMember"
            disabled
            placeholder=""
          ></el-input>
        </el-col>
        <el-col :span="4">
          <h4>上次修改時間:</h4>
          <el-input
            v-model="store.updatedAt"
            disabled
            placeholder=""
          ></el-input>
        </el-col>
      </el-row>
    </div>
    <div class="row input-spacing"></div>
    <div
      class="modal fade"
      id="editStorePasswordModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title" id="exampleModalLabel">修改密碼</h3>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div>
              <input
                v-model="store.password"
                type="text"
                required="required"
                class="inputstyle"
                placeholder="新密碼"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              關閉
            </button>
            <button type="button" class="btn btn-primary" @click="savePassword">
              儲存
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/assets/js/libs/API'
import checkPointInKml from '@/assets/js/tool/checkPointInKml.js'
import BehaviorRecorder from '@/assets/js/libs/BehaviorRecorder'
import StoreAPI from '@/assets/js/libs/Store'
import driverServiceCheckbox from '@/components/driver/DriverServiceCheckBox_1'
import { cookies } from '@/utils/cookies'

const store = new StoreAPI()
export default {
  name: 'EditStore',
  components: {
    driverServiceCheckbox,
  },
  data() {
    return {
      addData: [],
      tableData: [],
      map: '',
      store: {
        account: '',
        id: '',
        phone: '',
        address: '',
        password: '',
        name: '',
        modifyMember: '',
        contact_person: '',
        lat_gps: '',
        lng_gps: '',
        driverDiscount: 0,
        companyDiscount: 0,
        isHailingTaxi: '',
        note: '',
        passengerId: '',
        dispatchName: '',
        isAuthorize: false,
        address_gps: {
          coordinates: [0, 0],
        },
      },
      assginOptions: [
        { value: '排班', label: '排班' },
        { value: '空派', label: '空派' },
      ],
      phoneNumber: '',
      phoneList: [],
      landmarkList: [],
      landmark: '',
      keywordFindLandmark: '',
      isChangeLandmarkGPS: false,
      isModifyStoreLoading: false,
      isUpdareAppInfo: false,
      originalStoreData: null,
    }
  },
  methods: {
    async handleAdd(_, scope) {
      if (scope.start_date === undefined || scope.start_date === '') {
        return this.$msg('請輸入開始時間')
      }
      if (scope.end_date === undefined || scope.end_date === '') {
        return this.$msg('請輸入結束時間')
      }
      if (scope.type === undefined || scope.type === '') {
        return this.$msg('輸入派遣方式')
      }
      let payload = {
        startTime: scope.start_date + ':01',
        endTime: scope.end_date + ':00',
        minutes: scope.minutes,
        type: scope.type === '排班' ? 0 : 1,
      }
      if (payload.minutes === undefined || payload.minutes === '') {
        return this.$msg('請輸入數字')
      }
      let result = await store.addArrivalTime(this.$route.params.id, payload)
      if (result.success) {
        this.$msg(result.message)
        this.getStore(this.$route.params.id)
        return
      }
      this.$msg(result.message.message)
    },
    addRule() {
      this.tableData.push({
        type: '',
        start_date: '',
        end_date: '',
        minutes: '',
      })
    },
    async handleDelete(_, row) {
      let note = `${row.start_date}~${row.end_date}`
      let id = row.id
      let storeId = this.$route.params.id
      let result = await store.deleteArrivalTime(id, storeId, note)
      if (result.success) {
        this.$msg(`${result.message}`)
        this.getStore(storeId)
        return
      }
      this.$msg(`提取失敗- ${result.message}`)
    },
    async updateService() {
      let service = this.$refs.driverServiceList.getServiceList() || []

      const serviceString = service.length > 0 ? service.join(',') : ''
      console.log('服務列表:', service)
      console.log('傳給後端的服務字串:', serviceString)
      try {
        const { success, message } = await store.updateService(
          this.$route.params.id,
          serviceString,
        )
        if (success) {
          this.$msg(`${message}`)
          this.getStore(this.$route.params.id)
          console.log('更新成功')
          return
        }
        this.$msg(`提取失敗- ${message}`)
      } catch (error) {
        console.error('更新服務時出錯:', error)
        this.$msg(`提取失敗- ${error.message || '未知錯誤'}`)
      }
    },
    async createAppAccount() {
      let payload = {
        name: this.store.name,
        storeId: this.$route.params.id,
        address: this.store.address || null,
        lat_gps: this.store.address_gps.coordinates[1],
        lng_gps: this.store.address_gps.coordinates[0],
        isAuthorize: this.store.isAuthorize,
        account: this.store.account || null,
        password: this.store.password || null,
        dispatchArea: this.store.dispatchName,
      }
      if (payload.address === null) return this.$msg('請輸入地址')
      if (payload.account === null) return this.$msg('請輸入帳號')
      if (payload.password === null) return this.$msg('請輸入密碼')
      if (payload.lat_gps === 0) return this.$msg('請輸入經緯度')
      if (payload.lng_gps === 0) return this.$msg('請輸入經緯度')
      BehaviorRecorder.record(
        '點擊',
        '特約商家',
        '新增商家APP資料 - ' +
          this.store.name +
          '&&APP帳號:' +
          this.store.account +
          '&&可派車:' +
          (this.store.isAuthorize ? '是' : '否') +
          '&&地址:' +
          this.store.address +
          '&&派遣區:' +
          (this.store.dispatchName || ' '),
      )
      let result = await store.createStoreApp(payload)
      if (result.success) {
        this.$msg(`${result.message}`)
        if (result.success) {
          this.getStore(payload.storeId)
        }
        return
      }
      this.$msg(`提取失敗- ${result.message}`)
    },
    async removePhone(item) {
      let payload = {
        phone: item,
        id: this.$route.params.id,
      }
      BehaviorRecorder.record(
        '點擊',
        '特約商家',
        '移除商家電話:' + payload.phone + '&&商家名稱:' + this.store.name,
      )
      let result = await store.removeStorePhone(payload)
      if (result.success) {
        this.$msg(`${result.message}`)
        this.getStore(payload.id)
        return
      }
      this.$msg(`提取失敗- ${result.message.result}`)
    },
    async addNewPhone() {
      let payload = {
        phone: this.phoneNumber.replace(' ', ''),
        id: this.$route.params.id,
      }
      BehaviorRecorder.record(
        '點擊',
        '特約商家',
        '增加新商家電話:' + payload.phone + '&&商家名稱:' + this.store.name,
      )
      let result = await store.addStorePhone(payload)
      if (result.success) {
        this.$msg(`${result.message}`)
        this.phoneNumber = ''
        this.getStore(payload.id)
        return
      }
      this.$msg(`提取失敗- ${result.message}`)
    },
    setHailing(value) {
      this.store.isHailingTaxi = value
    },
    searchLandmark(landmark, cb) {
      this.landmarkList = []
      API.get(`landmark/gethailinglist/?key=${landmark.replace(/[ ]/g, '+')}`)
        .then((res) => {
          if (res.result === 'err') {
            cb([])
          } else {
            this.landmarkList = res.result.landmarkInfo
            for (let i of this.landmarkList) {
              i.value = i.name + '-' + i.address //將想要展示的資料作為value
            }
            cb(this.landmarkList)
          }
          this.landmark = -1
        })
        .catch((err) => {
          cb([])
          this.$msg(`提取失敗- ${err.message}`)
        })
    },
    selectLandmark(value) {
      this.store.dispatchName = ''
      let location = {
        name: value.name,
        latitude: value.addressGPS.coordinates[1],
        longitude: value.addressGPS.coordinates[0],
        address: value.address,
      }
      // 儲存地標資訊暫存
      this.store.lat_gps = location.latitude
      this.store.lng_gps = location.longitude
      this.store.address_gps.coordinates[0] = location.longitude
      this.store.address_gps.coordinates[1] = location.latitude

      this.isChangeLandmarkGPS = true
      this.store.address = location.name + '-' + location.address
      this._checkGPSInKml(location.latitude, location.longitude)
    },
    async updateAppInfo() {
      let payload = {
        name: this.store.name,
        id: this.store.id,
        account: this.store.account,
        address: this.store.address,
        lat_gps: this.store.address_gps.coordinates[1],
        lng_gps: this.store.address_gps.coordinates[0],
        isAuthorize: this.store.isAuthorize,
        dispatchArea: this.store.dispatchName,
      }
      this.isUpdareAppInfo = true
      BehaviorRecorder.record(
        '點擊',
        '特約商家',
        '更新商家APP資料 - ' +
          this.store.name +
          '&&(原)APP帳號:' +
          this.originalStoreData.account +
          '&&(新)APP帳號:' +
          this.store.account +
          '&&(原)可派車:' +
          (this.originalStoreData.isAuthorize ? '是' : '否') +
          '&&(新)可派車:' +
          (this.store.isAuthorize ? '是' : '否') +
          '&&(原)地址:' +
          this.originalStoreData.address +
          '&&(新)地址:' +
          this.store.address +
          '&&(原)派遣區:' +
          (this.originalStoreData.dispatchName || ' ') +
          '&&(新)派遣區:' +
          this.store.dispatchName,
      )
      let result = await store.updateStoreAppInfo(payload)
      if (result.success) {
        this.isUpdareAppInfo = false
        this.$msg('更新成功')
        this.keywordFindLandmark = ''
        this.getStore(this.$route.params.id)
        return
      }
      this.isUpdareAppInfo = false
      alert('更新失敗' + result.message)
    },
    getStore(id) {
      this.tableData = []
      API.get(`cooperative_store/storeDetail/?id=${id}`)
        .then((detail) => {
          if (!detail.success) {
            alert(detail.result)
            return
          }
          // 儲存原始資料
          this.originalStoreData = {
            name: detail.result.name,
            contactPerson: detail.result.contact,
            note: detail.result.note,
            companyDiscount: detail.result.companyDiscount,
            driverDiscount: detail.result.driverDiscount,
            account: detail.result.account,
            isAuthorize: detail.result.isAuthorize,
            address: detail.result.address,
            dispatchName: detail.result.dispatchName,
          }

          // 原本的資料載入
          this.store.id = id
          this.store.account = detail.result.account
          this.store.phone = detail.result.phone
          this.store.address = detail.result.address
          this.store.name = detail.result.name
          this.store.modifyMember = detail.result.modifyMember
          this.store.contact_person = detail.result.contact
          this.store.driverDiscount = detail.result.driverDiscount
          this.store.companyDiscount = detail.result.companyDiscount
          this.store.isAuthorize = detail.result.isAuthorize || false
          this.store.note = detail.result.note
          this.store.passengerId = detail.result.passenger_id || ''
          this.store.dispatchName = detail.result.dispatchName
          this.store.updatedAt = detail.result.updatedAt
          if (detail.result.arrivalTime.length !== 0) {
            for (let i = 0; i < detail.result.arrivalTime.length; i++) {
              this.tableData.push({
                id: detail.result.arrivalTime[i].arrivalTimeId,
                isload: true,
                start_date: detail.result.arrivalTime[i].startTime.slice(0, 5),
                end_date: detail.result.arrivalTime[i].endTime.slice(0, 5),
                minutes: detail.result.arrivalTime[i].minutes,
                type: detail.result.arrivalTime[i].type,
              })
            }
          }
          if (detail.result.address_gps === null) {
            this.store.address_gps.coordinates[0] = 0
            this.store.address_gps.coordinates[1] = 0
          } else {
            this.store.address_gps.coordinates[0] =
              detail.result.address_gps.coordinates[0]
            this.store.address_gps.coordinates[1] =
              detail.result.address_gps.coordinates[1]
          }
          if (detail.result.phone !== '') {
            this.phoneList = detail.result.phone.split(',')
          } else {
            this.phoneList = []
          }
          if (detail.result.service.length !== 0) {
            let array = detail.result.service.map((x) => {
              return { serivceId: x.teamServiceId, name: x.teamServiceName }
            })
            this.$refs.driverServiceList.setfillOutServiceListCheckBox(array)
          } else if (this.$route.params.isNewStore === 'true') {
            setTimeout(() => {
              // 新商家服務預設全選
              this.selectAllServices()
              // 強制更新一次服務 避免空服務
              this.updateService()
            }, 1500)
          }
        })
        .catch((err) => {
          this.$msg(`提取失敗- ${err.message}`)
        })
    },
    async deleteStore() {
      let id = this.$route.params.id
      if (confirm('確定刪除嗎')) {
        BehaviorRecorder.record(
          '點擊',
          '特約商家',
          '刪除商家&&商家名稱:' + this.store.name,
        )
        let result = await store.deleteStore(id)
        if (result.success) {
          alert(result.message)
          this.$router.replace({ name: 'StoreList' })
          return
        }
        alert(
          '刪除失敗，如果嘗試多次也無法刪除，請工程師處理。:' + result.message,
        )
      }
    },
    async savePassword() {
      let id = this.$route.params.id
      let position = 'service'
      if (cookies.get('Flag') === 'manager') {
        position = 'manager'
      }
      let payload = {
        account: this.store.account,
        password: this.store.password,
        passengerId: this.store.passengerId,
      }
      BehaviorRecorder.record(
        '點擊',
        '特約商家',
        '更新APP密碼&&商家名稱:' + this.store.name,
      )
      if (confirm('確定更新密碼嗎')) {
        let result = await store.updateStorePwd(id, position, payload)
        if (result.success) {
          $('#editStorePasswordModal').modal('hide')
          alert('更新成功')
          return
        }
        this.$msg(`更新失敗- ${result.message}`)
      }
    },
    openModal() {
      $('#editStorePasswordModal').modal('show')
    },
    async updatedStore() {
      let regex = /^[0-9\s]*$/
      if (!regex.test(this.store.driverDiscount)) {
        alert('企業折扣格式錯誤')
        return
      }
      if (!regex.test(this.store.companyDiscount)) {
        alert('司機折扣格式錯誤')
        return
      }

      this.store.id = this.$route.params.id

      if (!this.isChangeLandmarkGPS) {
        this.store.lat_gps = this.store.address_gps.coordinates[1]
        this.store.lng_gps = this.store.address_gps.coordinates[0]
      }

      this.isModifyStoreLoading = true

      BehaviorRecorder.record(
        '點擊',
        '特約商家',
        '更新商家資料 - ' +
          this.store.name +
          '&&(原)商家名稱:' +
          this.originalStoreData.name +
          '&&(新)商家名稱:' +
          this.store.name +
          '&&(原)聯絡人:' +
          this.originalStoreData.contactPerson +
          '&&(新)聯絡人:' +
          this.store.contact_person +
          '&&(原)備註:' +
          this.originalStoreData.note +
          '&&(新)備註:' +
          this.store.note +
          '&&(原)企業折扣:' +
          this.originalStoreData.companyDiscount +
          '&&(新)企業折扣:' +
          this.store.companyDiscount +
          '&&(原)司機折扣:' +
          this.originalStoreData.driverDiscount +
          '&&(新)司機折扣:' +
          this.store.driverDiscount,
      )
      const result = await store.updateStoreInfo(this.store)
      if (result.success) {
        this.isModifyStoreLoading = false
        this.$msg('更新成功')
        this.getStore(this.$route.params.id)
        return
      }
      this.isModifyStoreLoading = false
      alert('更新失敗:' + result.message)
    },
    _checkGPSInKml(lat, lng) {
      const gps = [lng, lat]
      // 提取所有派遣區
      const dispatchArea = localStorage.getItem('DispatchAreaArray')
      if (!dispatchArea) return
      const dispatchArray = dispatchArea.split(',')
      // gps與派遣區做比對，並且倒序遍歷
      for (let i = dispatchArray.length - 1; i >= 0; i--) {
        const dispatch = localStorage.getItem(`${dispatchArray[i]}`)
        const points = checkPointInKml.parseKmlToPointsArray(dispatch)
        if (checkPointInKml.rayCasting(gps, points) === 'in') {
          const id = parseInt(dispatchArray[i].replace('dispatch-', ''))
          // 回傳排班區與派遣區，無：無派遣區
          this._takeCurrentDispatchInfo(id)
          break
        }
      }
    },
    _takeCurrentDispatchInfo(id) {
      API.get(`/dispatch-area/info/?id=${id}&search=id`)
        .then((res) => {
          this.$set(this.store, 'dispatchName', res.result.name)
        })
        .catch((err) => {
          this.$msg(`提取失敗- ${err.message}`)
        })
    },
    selectAllServices() {
      if (
        this.$refs.driverServiceList &&
        this.$refs.driverServiceList.apiServiceList
      ) {
        // 獲取所有服務 ID
        const allServiceIds = this.$refs.driverServiceList.apiServiceList.map(
          (service) => service.id,
        )

        // 使用 setfillOutServiceListCheckBoxArray 方法設定所有服務為選中
        this.$refs.driverServiceList.setfillOutServiceListCheckBoxArray(
          allServiceIds,
        )
      } else {
        // 如果元件尚未載入，延遲執行
        setTimeout(() => {
          this.selectAllServices()
        }, 1000)
      }
    },
  },
  mounted() {
    this.getStore(this.$route.params.id)

    // 清除 isNewStore 參數，避免頁面重新載入時仍然全選
    if (this.$route.params.isNewStore) {
      const newParams = { ...this.$route.params }
      delete newParams.isNewStore
      this.$router.replace({
        name: this.$route.name,
        params: newParams,
        query: this.$route.query,
      })
    }
  },
}
</script>

<style scoped>
.input-spacing {
  margin-bottom: 10px;
}

html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
}

.hr-gray {
  height: 1px;
  border: none;
  background-color: #363636;
}

h4 {
  background-color: bisque;
  display: inline-block;
  /* margin: -5px; */
}
</style>



// WEBPACK FOOTER //
// src/pages/specialContract/EditStore.vue